//import ReactEffect, { useEffect } from 'react';
import React, { useEffect } from 'react';
import './calendly.scss';

const CalendlyEmbed = ({ payload }) => {
  const { id, style, number, title, calendly:properties} = payload

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  return (
    <section className="ss-calendly">
      <div
        id="calandlyid"
        className="calendly-inline-widget"
        data-url={properties.url}
        style={{ minWidth: '320px', height: '800px' }}
      ></div>
    </section>
  );
};


export default CalendlyEmbed;